import { adminApi } from '@/core/api/admin'

export const {
  useGetAdminAccountsQuery,
  useGetAdminEstablishmentQuery,
  useGetAdminEstablishmentsQuery,
  useGetAdminStaffsQuery,
  useLazyGetAdminStaffsQuery,
  useGetAirtableConfigQuery,
  useDiscoverAirtableBasesMutation,
  useEnableAirtableInboundSyncMutation,
  useExportMedConnectPatientsToAirtableMutation,
  useGetAirtableInboundSyncStatusQuery,
  useGetAirtablePatientsTableStatusQuery,
  useInitializeAirtablePatientsTableMutation,
  useUpdateAirtableConfigMutation,
  useVerifyAirtableInboundSyncMutation,
  useAssignLicensesToStaffMutation,
  useSetStaffSimplifiedReceptionModeMutation,
  useUpdateAdminEstablishmentMutation,
  useDeleteAdminStaffMutation,
  useUpdateEstablismentLogoMutation,
} = adminApi
